import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, Toaster } from '@rnd-payplus/alloy-react';
import { Provider } from 'react-redux';

import { store } from './store';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TenantsPage from './pages/TenantsPage';
import IntegrationsPage from './pages/IntegrationsPage';
import DataFlowsPage from './pages/DataFlowsPageComplete';
import AnalyticsPage from './pages/AnalyticsPage';
import SecurityPage from './pages/SecurityPage';
import ConfigurationPage from './pages/ConfigurationPage';
import ObservabilityPage from './pages/ObservabilityPage';
import ProfilePage from './pages/ProfilePage';
import HelpPage from './pages/HelpPage';
import ServicesHealthPage from './pages/ServicesHealthPage';
import SAPPaymentsPage from './pages/SAPPaymentsPage';
import DataMappingsPage from './pages/DataMappingsPage';
import OnboardingWizardPage from './pages/OnboardingWizardPage';
import InvoiceOCRPage from './pages/InvoiceOCRPage';
import StorageConnectionsPage from './pages/StorageConnectionsPage';
import WorkflowsPage from './pages/WorkflowsPage';
import ProductBacklogPage from './pages/ProductBacklogPage';
import SettingsPage from './pages/SettingsPage';
import IngestPage from './pages/IngestPage';

// Layout
import MainLayout from './components/Layout/MainLayout';

// Auth guard
import { PrivateRoute } from './components/Auth/PrivateRoute';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider defaultTheme="light" storageKey="ch-theme">
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes */}
            <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/tenants" element={<TenantsPage />} />
              <Route path="/integrations" element={<IntegrationsPage />} />
              <Route path="/data-flows" element={<DataFlowsPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/configuration" element={<ConfigurationPage />} />
              <Route path="/observability" element={<ObservabilityPage />} />
              <Route path="/services-health" element={<ServicesHealthPage />} />
              <Route path="/ingest" element={<IngestPage />} />
              <Route path="/sap-payments" element={<SAPPaymentsPage />} />
              <Route path="/data-mappings" element={<DataMappingsPage />} />
              <Route path="/ai-mapper" element={<Navigate to="/data-mappings" replace />} />
              <Route path="/onboarding-wizard" element={<OnboardingWizardPage />} />
              <Route path="/invoice-ocr" element={<InvoiceOCRPage />} />
              <Route path="/storage-connections" element={<StorageConnectionsPage />} />
              <Route path="/workflows" element={<WorkflowsPage />} />
              <Route path="/backlog" element={<ProductBacklogPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
        <Toaster />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
